export default "__VITE_ASSET__DOTZjJrR__"